export default {
  use() {
    //extend array method
    Array.prototype.$$any = function(handler /*:[nullable]function(item)->boolean*/) {
      if (!handler) return this.length > 0;
      else {
        for (var i = 0; i < this.length; i++) {
          if (handler(this[i])) return true;
        }
      }

      return false;
    };
    Array.prototype.$$all = function(handler /*:function(item)->boolean*/) {
      if (!handler || this.length < 1) return false;

      for (var i = 0; i < this.length; i++) {
        if (!handler(this[i])) return false;
      }

      return true;
    };
    Array.prototype.$$count = function(handler /*:function(item)->boolean*/) {
      if (!handler || this.length < 1) return this.length;

      let count = 0;
      for (var i = 0; i < this.length; i++) {
        if (handler(this[i])) count++;
      }

      return count;
    };
    Array.prototype.$$each = function(handler /*:function(item,index)*/) {
      if (this.length < 1 || !handler) return;

      for (var i = 0; i < this.length; i++) {
        handler(this[i], i);
      }
    };
    Array.prototype.$$where = function(handler /*:function(item)->boolean*/) {
      if (!handler || this.length < 1) return [];

      var res = [];
      for (var i = 0; i < this.length; i++) {
        if (handler(this[i])) res.push(this[i]);
      }
      return res;
    };
    Array.prototype.$$first = function(handler /*:[nullable]function(item)->boolean*/) {
      if (!handler) return this.length < 1 ? null : this[0];
      else {
        for (var i = 0; i < this.length; i++) {
          if (handler(this[i])) return this[i];
        }

        return null;
      }
    };
    Array.prototype.$$last = function(filter) {
      if (this.length < 1) return null;
      if (!filter) return this[this.length - 1];
      for (let i = this.length - 1; i > -1; i--) {
        if (filter(this[i])) return this[i];
      }

      return null;
    };

    Array.prototype.$$index = function(filter) {
      for (var i = 0; i < this.length; i++) {
        if (filter(this[i])) return i;
      }
      return -1;
    };

    Array.prototype.$$select = function(itemProcessor /*:function(item)->object*/) {
      if (!itemProcessor) return this;

      var res = [];
      for (var i = 0; i < this.length; i++) {
        res.push(itemProcessor(this[i]));
      }
      return res;
    };

    Array.prototype.$$loop = function(handler) {
      for (var i = 0; i < this.length; i++) {
        handler(this[i], i);
      }
    };

    Array.prototype.$$reverseLoop = function(handler) {
      for (var i = this.length - 1; i > -1; i--) {
        handler(this[i], i);
      }
    };

    Array.prototype.$$remove = function(item) {
      if (typeof item == "function") {
        let res = [];
        for (let i = 0; i < this.length; i++) {
          if (item(this[i])) {
            res.push(...this.splice(i, 1));
            i--;
          }
        }
        return res;
      } else {
        const pos = this.indexOf(item);
        return pos > -1 ? this.splice(pos, 1) : [];
      }
    };
    Array.prototype.$$clear = function() {
      if (this.length > 0) this.splice(0, this.length);
    };

    Array.$$isBlank = function(arr) {
      return !arr || arr.length <= 0;
    };

    function flatArray(arr, collector) {
      for (let i = 0; i < arr.length; i++) {
        if (!Object.hasOwnProperty(arr, i)) continue;
        const ele = arr[i];
        if (ele != null && ele instanceof Array) {
          flatArray(ele, collector);
        } else {
          collector.push(ele);
        }
      }
    }
    Array.prototype.$$flat = function() {
      if (this.flat) return this.flat();
      else {
        let collector = [];
        flatArray(this, collector);
        return collector;
      }
    };

    window.$util = {
      each(obj, handler) {
        for (var i = 0; i < obj.length; i++) {
          handler(obj[i], i);
        }
      },
      any(obj, handler) {
        for (var i = 0; i < obj.length; i++) {
          if (handler(obj[i], i)) return true;
        }

        return false;
      },
      index(obj, handler) {
        for (var i = 0; i < obj.length; i++) {
          if (handler(obj[i], i)) return i;
        }

        return -1;
      },
    };
  },
};
